module.exports = __webpack_public_path__ + "media/images/recruitment/blog/blog-5-d95df7f143cc4b1b52cdc6800c5943bd.jpg";